import React, { useState, useEffect } from "react";
import "flowbite";
import "react-phone-number-input/style.css";
import Login from "./Login";
// import Registration from "./Registration";
import Paymentmethod from "./Paymentmethod";
import Verifyregistration from "./Verifyregistration";
import Verifylogin from "./Verifylogin";
// import Signinoption from "./Signinoption";
import Phonenologin from "./Phonenologin";
// import Fiat from "./Fiat";
import { useAccount } from "wagmi";
import axios from "axios";
import { useSigner } from "wagmi";
import { ethers } from "ethers";
import { SubscriptionAddress } from "./Contracts/Subscription";
import { SubscriptionAbi } from "./Contracts/Subscription";
import fiat from "./images/fiat.jpg";
import crypto from "./images/crypto.png";
import { ToastContainer, toast } from "react-toastify";
const privateKey = process.env.REACT_APP_ADMIN_PRIVATEkEY;
const NODE_URL = process.env.REACT_APP_NODE_URL;

const customProvider = new ethers.providers.JsonRpcProvider(NODE_URL);
const customSigner = new ethers.Wallet(privateKey, customProvider);
const Pricing = () => {
  const { BigNumber } = require("ethers");
  const [plan, setPlans] = useState([]);
  const [boxes, setBoxes] = useState([]);
  const { address } = useAccount();
  const [showModal, setShowModal] = useState(false);

  const { data: signer } = useSigner();
  let contract;
  let customContract;

  if (signer) {
    contract = new ethers.Contract(
      SubscriptionAddress,
      SubscriptionAbi,
      signer
    );
  }

  if (customSigner) {
    customContract = new ethers.Contract(
      SubscriptionAddress,
      SubscriptionAbi,
      customSigner
    );
  }
  console.log("Subscription", customContract);

  // const getSubscriber = async () => {
  //   await contract?.getUserAllBoxesInfo(address).then((info) => {
  //     console.log("Info", info);
  //     for (var i = 0; i <= 1; i++) {
  //       setBoxes((oldinfo) => [...oldinfo, info[i]]);
  //     }
  //   });

  //   // }
  // };
  console.log("Boxes", boxes);
  const getPlans = async () => {
    const totalAgents = await customContract?.totalSubscriptionPlans();
    const bigNumber = BigNumber.from(totalAgents);
    const bigNumberString = bigNumber.toString();
    console.log("bignmber", bigNumberString);
    // setPlans([]);
    let c = [];
    for (var i = 0; i < bigNumberString; i++) {
      await customContract?.getSubscriptionPlanDetails(i).then((res) => {
        console.log("Result", res);
        const price = BigNumber.from(res.price);
        const prices = price.toString();
        const wei = ethers.utils.formatEther(prices.toString());
        // console.log("ressss",res)
        c.push({
          price: prices,
          storage: ethers.BigNumber.from(res.storageAvailable).toString(),
        });
        // console.log("asdad", prices);
        // console.log("response",res)
      });
    }
    setPlans(c);
  };

  const openModal = () => {
    showModal ? setShowModal(false) : setShowModal(true);
  };
  console.log("plans", plan);
  useEffect(() => {
    if (customSigner) {
      // if (plan.length == 0) {
      getPlans();
      // }
    }
  }, [customSigner]);
  return (
    <div className="pb-6 bg-gradient-to-bl from-[#212445] via-[#212445] to-[#462E52]">
      <ToastContainer
      // position="top-right"
      // autoClose={5000}
      // hideProgressBar={false}
      // newestOnTop={false}
      // closeOnClick
      // rtl={false}
      // pauseOnFocusLoss
      // draggable
      // pauseOnHover
      // theme="dark"
      />

      <h1 className="text-4xl md:text-5xl font-bold text-white  md:px-28 px-4 ">
        Box Options
        <p className="text-[#b3b3b3] text-lg font-normal my-2 text-justify">
          Buy a Box! (one time fee per box! No strings, no hassle!)
        </p>
      </h1>
      <div
        // data-modal-target="payment-modal"
        // data-modal-toggle="payment-modal"
        className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-10 md:px-28 px-4 py-10 "
      >
        {plan?.map((item, index) => (
          <div
            className="shadow-lg shadow-gray-900 rounded-2xl  p-8 lg:w-[300px]"
            key={index}
          >
            <h1 className="font-bold  text-white text-xl">
              {index == 0 ? "Small (up to 10MB)" : index == 1 ? "Medium (up to 25MB)" : "Large (up to 50MB)"}
            </h1>
            <h1 className="text-lg font-extrabold text-transparent bg-clip-text bg-gradient-to-b py-2 from-[#7789b8] to-[#8B53E8]">
            {index == 0 ? "$4 USD (Credit Card or " : index == 1 ? "$8 USD (Credit Card or " : "$10 USD (Credit Card or "}

              {/* {ethers.utils.formatEther(item.price)} */}
               $Matic)
            </h1>
            <h1 className="text-lg font-extrabold text-transparent bg-clip-text bg-gradient-to-b py-2 from-[#7789b8] to-[#8B53E8]">
              {item.storage /1024} MB
            </h1>
            <h1 className="text-[#b3b3b3]  text-justify">
              {index == 0
                ? "For uploading standard files, such as the following file types: .PDF, .JPG, .PNG, .DOC, .XLS, .PPT, .TXT, .HTML, .PSD, .GIF, .MOV, .RAW, .MP3, .MP4, .AVI"
                : index == 1
                ? "For uploading standard files, such as the following file types: .PDF, .JPG, .PNG, .DOC, .XLS, .PPT, .TXT, .HTML, .PSD, .GIF, .MOV, .RAW, .MP3, .MP4, .AVI"
                : "For uploading standard files, such as the following file types: .PDF, .JPG, .PNG, .DOC, .XLS, .PPT, .TXT, .HTML, .PSD, .GIF, .MOV, .RAW, .MP3, .MP4, .AVI"}
            </h1>

            {/* <h1 className="font-extrabold  text-white text-2xl">
              <br/>{index == 0 ? "$4 USD" : index == 1 ? "$8 USD" : "$10 USD"}
            </h1> */}
            <center>
              <button
                onClick={() => {
                  localStorage.setItem("plan", item?.price);
                  localStorage.setItem("package", index);
                  openModal();
                }}
                className="bg-gradient-to-r rounded-full  from-[#2C55B9] to-[#8B53E8] text-white font-bold py-2 px-10  mt-5"
              >
                {index == 0 ? "$4 USD" : index == 1 ? "$8 USD" : "$10 USD"}
              </button>
            </center>
          </div>
        ))}
        {/* <div
            className="shadow-lg shadow-gray-900 rounded-2xl  p-8 min-w-[300px]"
           
            onClick={openModal}
          >
            <h1 className="font-bold  text-white text-xl">Silver</h1>
            <h1 className="text-lg font-extrabold text-transparent bg-clip-text bg-gradient-to-b py-2 from-[#7789b8] to-[#8B53E8]">
            0.0000000000000001 Matic
            </h1>
            <h1 className="text-lg font-extrabold text-transparent bg-clip-text bg-gradient-to-b py-2 from-[#7789b8] to-[#8B53E8]">
              10240 KB
            </h1>
            <h1 className="text-[#9EA0A1]  ">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              Vestibulum elementum, libero ac porttitor convallis, ante lacus
              euismod nunc, non dapibus tellus elit imperdiet nisi.
            </h1>
            <center>
              <button
                onClick={() => {
                  localStorage.setItem("plan", 100);
                  localStorage.setItem("package", 0);
                }}
                className="bg-gradient-to-r rounded-full  from-[#2C55B9] to-[#8B53E8]   text-white font-bold py-2 px-10  mt-10"
              >
                Select Plan
              </button>
            </center>
          </div>
         <div
            className="shadow-lg shadow-gray-900 rounded-2xl  p-8 min-w-[300px]"
           
            onClick={openModal}
          >
            <h1 className="font-bold  text-white text-xl">Gold</h1>
            <h1 className="text-lg font-extrabold text-transparent bg-clip-text bg-gradient-to-b py-2 from-[#7789b8] to-[#8B53E8]">
            0.0000000000000002 Matic
            </h1>
            <h1 className="text-lg font-extrabold text-transparent bg-clip-text bg-gradient-to-b py-2 from-[#7789b8] to-[#8B53E8]">
            51200 KB
            </h1>
            <h1 className="text-[#9EA0A1]  ">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              Vestibulum elementum, libero ac porttitor convallis, ante lacus
              euismod nunc, non dapibus tellus elit imperdiet nisi.
            </h1>
            <center>
              <button
                onClick={() => {
                  localStorage.setItem("plan", 200);
                  localStorage.setItem("package", 1);
                }}
                className="bg-gradient-to-r rounded-full  from-[#2C55B9] to-[#8B53E8]   text-white font-bold py-2 px-10  mt-10"
              >
                Select Plan
              </button>
            </center>
          </div>
         <div
            className="shadow-lg shadow-gray-900 rounded-2xl  p-8 min-w-[300px]"
           
            onClick={openModal}
          >
            <h1 className="font-bold  text-white text-xl">Platinum</h1>
            <h1 className="text-lg font-extrabold text-transparent bg-clip-text bg-gradient-to-b py-2 from-[#7789b8] to-[#8B53E8]">
            0.0000000000000003 Matic
            </h1>
            <h1 className="text-lg font-extrabold text-transparent bg-clip-text bg-gradient-to-b py-2 from-[#7789b8] to-[#8B53E8]">
            102400 KB
            </h1>
            <h1 className="text-[#9EA0A1]  ">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              Vestibulum elementum, libero ac porttitor convallis, ante lacus
              euismod nunc, non dapibus tellus elit imperdiet nisi.
            </h1>
            <center>
              <button
                onClick={() => {
                  localStorage.setItem("plan", 300);
                  localStorage.setItem("package", 2);
                }}
                className="bg-gradient-to-r rounded-full  from-[#2C55B9] to-[#8B53E8]   text-white font-bold py-2 px-10  mt-10"
              >
                Select Plan
              </button>
            </center>
          </div> */}
      </div>
      <img
        src="https://themegenix.net/wp/nerko/wp-content/uploads/2022/12/divider-01.svg"
        className="mx-auto py-10"
      />

      {/* <Registration /> */}
      {/* {showModal? (
          ):("")} */}
      {/* <Paymentmethod /> */}

      {/* <Login /> */}

      {/* <Verifyregistration /> */}
      {/* <Verifylogin /> */}
      {/* <Signinoption /> */}
      {/* <Phonenologin /> */}
      {/* <Fiat /> */}

      {showModal ? <Paymentmethod modalClose={() => openModal()} /> : ""}
    </div>
  );
};

export default Pricing;
